import { Try } from './utils'

// https://github.com/twigjs/twig.js/issues/787
// twig/twig is designed for node use, and relies on path.. importing it in browser explodes completely
// twig/twig.min is designed for browser use, and relies on window.. importing it in node fails functionally, but doesn't explode
// so, default to twig/twig.min which works for apps, fails for node, import twig/twig for node specifically using OVERRIDE_TWIG
const BROWSER_TWIG = () => Try(() => require('twig/twig.min'))
let OVERRIDE_TWIG = undefined

export function setTwig(twigLoader) {
  OVERRIDE_TWIG = twigLoader
}

export function loadTwig() {
  return OVERRIDE_TWIG ? OVERRIDE_TWIG() : BROWSER_TWIG()
}
